export default {
  name: "Employment-Based Nonimmigrant Visa Information",
  prefix: "A",
  pageInfo: {
    text: "Please read and review the filing instructions carefully before completing the Form ETA-9035 or 9035E. A copy of the instructions can be found at <a href='https://www.dol.gov/agencies/eta'>https://www.dol.gov/agencies/eta</a>. In accordance with Federal Regulations at 20 CFR 655.730(b), incomplete or obviously inaccurate Labor Condition Applications (LCAs) will not be certified by the Department of Labor (DOL). For all submissions, both electronic (Form ETA-9035E) or paper (Form ETA-9035) where the employer has notified DOL that it will submit this form non-electronically due to a disability or received permission from DOL to file non-electronically due to lack of Internet access, <u>ALL</u> required fields/items containing an asterisk (*) must be completed.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          isGroup: {
            machine_name: "a1_visa_type",
            code: "A.1",
            label:
              "Indicate the type of visa classification supported by this application",
            tooltip:
              "Enter one of the following classification symbols to indicate the type of visa supported by this application: “H-1B,” “H-1B1 Chile,” “H-1B1 Singapore,” or “E-3 Australia.” Select only one visa classification for all non-immigrant workers employed pursuant to the LCA.",
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "H-1B",
                value: "H-1B",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "H-1B1 Chile",
                value: "H-1B1 Chile",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "H-1B1 Singapore",
                value: "H-1B1 Singapore",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "E-3 Australian",
                value: "E-3 Australian",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
  ],
};
